<template>
  <div class="transition">
    <BasicText size="h5">Quel établissement ou entreprise réalise cette demande?</BasicText>
    <WrapperAutocomplete
      v-model="data"
      key-id="identifiantEntiteJuridique"
      key-label="entite.denomination"
      placeholder="Siren, siret ou dénomination..."
      :search-min-length="props.in.length > 5 ? 1 : 0"
      label="Entreprise ou établissement rattaché"
      strict
      :search
      :search-formater="sirenSiretSearchFormater"
    >
      <template v-slot="item">
        <div class="item">
          <BasicText
            weight="bold"
            size="body-m"
          >
            {{ item.entite.denomination }}
          </BasicText>
          <BasicText
            v-if="item.typeEntiteJuridique === 'Entreprise'"
            size="body-s"
          >
            Siren : {{ item.entite.siren }}
          </BasicText>
          <BasicText
            v-else
            size="body-s"
          >
            Siret : {{ item.entite.siren }} {{ item.entite.nic }}
          </BasicText>
        </div>
      </template>
    </WrapperAutocomplete>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import type { RattachementDTO } from '@/features/api/extranet/dto/Profil'
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { isNullUndefinedOrEmptyString } from '@/features/shared/tools'
  import { sirenSiretSearchFormater } from '@/features/interface/shared/tools'

  const props = defineProps<CarteProps<RattachementDTO[], RattachementDTO>>()
  const emits = defineEmits<CarteEvents<RattachementDTO>>()

  const data = computed<RattachementDTO | undefined>({
    get: () => props.out,
    set: (value) => {
      const outReady = !isNullUndefinedOrEmptyString(value?.identifiantEntiteJuridique)
      emits('outChanged', outReady, value)
    },
  })

  const search = (query: string) => {
    if (isNullUndefinedOrEmptyString(query)) return props.in

    query = query.toLowerCase()
    return props.in.filter(
      (item) =>
        item.identifiantEntiteJuridique.startsWith(query) ||
        (item.entite.denomination?.toLowerCase().indexOf(query) ?? -1) >= 0,
    )
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';
</style>
